import styles from "./ModalShiftDescriptionContainer.module.scss";
import React, {FC} from "react";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import dayjs from "dayjs";
import ScheduleOutlinedIcon from "@material-ui/icons/ScheduleOutlined";

interface ModalShiftDescriptionContainerProps {
    header?: string;
    address: string;
    from: string;
    to: string;
    children?: React.ReactNode;
}

const ModalShiftDescriptionContainer: FC<ModalShiftDescriptionContainerProps> = (
    {
        header,
        address,
        from,
        to,
        children
    }) => {
    return <div className={styles.shiftDescriptionBox}>
        <div className={styles.shiftBoxHeader}>{header}</div>
        <div className={styles.shiftBoxLocation}>{address}</div>
        <div className={styles.shiftBoxDate}>
            <div className={styles.date}>
                <DateRangeOutlinedIcon className={styles.shiftDateIcon}/>
                {dayjs(from).format('dddd MMM, D')}
            </div>
            <div className={styles.time}>
                <ScheduleOutlinedIcon className={styles.shiftDateIcon}/>
                {`${dayjs(from).format('h:mma')} - ${dayjs(to).format('h:mma')}`}
            </div>
        </div>
        {children}
    </div>
}

export default ModalShiftDescriptionContainer;